import { Flex, Box, Text } from "rebass/styled-components";
import Heading from "../common/Heading";
import Icon from "../common/Icon";

import {
  stepsGroupStyles,
  simpleStepStyles
} from "../../lib/styles/landingStyles";

interface SimpleStepProps {
  description: string;
  icon?: string;
  step?: number | boolean;
  color?: string;
}

export function SimpleStep(props: SimpleStepProps) {
  const { icon, step, description, color } = props;
  const containerStyle = {
    ...simpleStepStyles.flex,
    ...(icon && { pt: "3px", pl: "3px" })
  };
  const iconBoxStyle = {
    ...simpleStepStyles.boxIcon,
    ...(icon && { pt: "3px", pl: "3px" })
  };

  return (
    <Flex sx={containerStyle}>
      <Box sx={iconBoxStyle}>
        {icon && <Icon name={icon} color={color} />}
        {!icon && step && <Box sx={simpleStepStyles.stepIcon}>{step}</Box>}
      </Box>
      <Box sx={simpleStepStyles.boxText}>
        <Text as="p" sx={simpleStepStyles.text}>
          {description}
        </Text>
      </Box>
    </Flex>
  );
}

export interface StepInfo {
  title?: string;
  infoList: string[];
  icon?: string;
  steps?: boolean;
  color?: string;
}

interface StepsGroupProps {
  variant: string;
  infoLeft: StepInfo;
  infoRight?: StepInfo;
}

export function StepSection({ stepInfo }: { stepInfo: StepInfo }) {
  return (
    <>
      <Heading as="h2" sx={stepsGroupStyles.heading}>
        {stepInfo.title}
      </Heading>
      <Flex flexDirection="column" mt={1}>
        {stepInfo.infoList.map((desc, i) => (
          <SimpleStep
            key={i}
            description={desc}
            icon={stepInfo.icon}
            step={stepInfo.steps && i + 1}
            color={stepInfo.color}
          />
        ))}
      </Flex>
    </>
  );
}

function StepsGroup(props: StepsGroupProps) {
  const { variant, infoLeft, infoRight } = props;

  // If there is not block on the right we want the info with 100% width
  const styleLeft = infoRight
    ? stepsGroupStyles.mainBoxLeft
    : stepsGroupStyles.mainBoxUnique;

  const containerStyle =
    stepsGroupStyles.flex[variant as keyof typeof stepsGroupStyles.flex];

  return (
    <Flex sx={containerStyle}>
      <Box sx={styleLeft}>
        <StepSection stepInfo={infoLeft} />{" "}
      </Box>
      {infoRight && (
        <Box sx={stepsGroupStyles.mainBoxRight}>
          <StepSection stepInfo={infoRight} />
        </Box>
      )}
    </Flex>
  );
}

export default StepsGroup;
